import { DropdownButton } from 'react-bootstrap';

import './DropdownButton.scss';

export default DropdownButton;